import React, { FC } from "react";
import classNames from "classnames";
import { Fade } from "react-awesome-reveal";
import { GatsbyImage } from "gatsby-plugin-image";
import { getGatsbyImage } from "gatsby-plugin-storyblok-image";
import { DEFAULT_FADE_DURATION } from "@app/constants";
import { useIsMDMediaQuery, useIsXLMediaQuery } from "@app/hooks";
import { Asset } from "../../models";
import { defaultMaxWidthValues } from "./constants";
import { isVectorImage } from "./helpers";

type Props = {
  media: Asset;
  maxWidthMobile?: string;
  maxWidthTablet?: string;
  maxWidthPC?: string;
  measure?: string;
};

export const SimpleImage: FC<Props> = ({
  media,
  maxWidthMobile,
  maxWidthTablet,
  maxWidthPC,
  measure,
}) => {
  const isVector = isVectorImage(media.filename);
  const isXLScreen = useIsXLMediaQuery();
  const isMDScreen = useIsMDMediaQuery();

  return (
    <Fade duration={DEFAULT_FADE_DURATION} triggerOnce>
      <div
        className={classNames(
          "mt-20 flex justify-center px-5",
          "lg:mt-25 lg:px-16",
          "xl:mt-40 xl:px-24",
        )}
      >
        {isVector ? (
          <div
            className={classNames(
              "flex w-full justify-center xl:max-w-[1235px]",
            )}
          >
            <img
              src={media.filename}
              alt={media.alt}
              style={{
                maxWidth: `${
                  isXLScreen
                    ? maxWidthPC ?? defaultMaxWidthValues.values.XL
                    : isMDScreen
                      ? maxWidthTablet ?? defaultMaxWidthValues.values.MD
                      : maxWidthMobile ?? defaultMaxWidthValues.values.SM
                }${measure ?? defaultMaxWidthValues.measure}`,
              }}
            />
          </div>
        ) : (
          <GatsbyImage
            image={getGatsbyImage(media.filename, { layout: "fullWidth" })}
            alt={media.alt}
            className={classNames(
              "aspect-[3/2] w-full rounded-lg",
              "xl:max-w-[1235px]",
            )}
          />
        )}
      </div>
    </Fade>
  );
};
